/* eslint-disable @typescript-eslint/no-explicit-any */
import { Card, CardContent, CardHeader } from '@/components/ui/card'
import { formatCFA, sanitizeLinePoints } from '@/lib/utils'
import type { XYPoint } from '@/types/backend'
import { ResponsiveLine } from '@nivo/line'
import type React from 'react'

type BilanVentesProps = {
  salesMonthly: XYPoint[]
  gridColor: string
  gridOpacity: number
  emptyMsg?: string
}

const ChartEmpty = ({ msg }: { msg: string }) => (
  <div className='h-full flex items-center justify-center text-sm text-muted-foreground'>
    {msg}
  </div>
)

const BilanVentes: React.FC<BilanVentesProps> = ({
  salesMonthly,
  gridColor,
  gridOpacity,
  emptyMsg = "Aucune donnée pour l'année sélectionnée.",
}) => {
  const points = sanitizeLinePoints(salesMonthly as any)

  return (
    <Card className='min-h-[360px]'>
      <CardHeader>
        <h4 className='text-lg font-medium'>Ventes par mois</h4>
      </CardHeader>
      <CardContent className='h-[300px]'>
        {points.length ? (
          <ResponsiveLine
            data={[{ id: 'Ventes', data: points }]}
            margin={{ top: 10, right: 10, bottom: 40, left: 48 }}
            xScale={{ type: 'point' }}
            yScale={{
              type: 'linear',
              min: 'auto',
              max: 'auto',
              stacked: false,
              reverse: false,
            }}
            axisBottom={{ tickPadding: 12, tickRotation: -30 }}
            axisLeft={{ tickPadding: 6 }}
            enablePoints
            useMesh
            enableGridX
            enableGridY
            gridYValues={5}
            theme={{
              grid: { line: { stroke: gridColor, strokeOpacity: gridOpacity } },
              tooltip: { container: { fontSize: 12, borderRadius: 8 } },
            }}
            colors={['#2563eb']}
            tooltip={({ point }) => (
              <div className='rounded-md border dark:bg-primary bg-white p-2 text-xs shadow'>
                <div>
                  Mois: <b>{String(point.data.xFormatted ?? point.data.x)}</b>
                </div>
                <div>
                  Ventes: <b>{formatCFA(Number(point.data.y))}</b>
                </div>
              </div>
            )}
          />
        ) : (
          <ChartEmpty msg={emptyMsg} />
        )}
      </CardContent>
    </Card>
  )
}

export default BilanVentes
